import { Box, Button, CardMedia, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CoordContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  padding: '8px',
  border: '1px solid #D7D8DB',
  borderRadius: '10px',
  margin: '16px 0 26px',
  height: '50px',
}));

export const FlexBox = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
}));

export const BoldTypography = styled(Typography)(() => ({
  fontWeight: '600',
}));

export const MapButton = styled(Button)(({ theme }) => ({
  borderRadius: '10px',
  width: '100%',
  border: `2px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  fontWeight: '600',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  maxWidth: '400px',
  width: '100%',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  textTransform: 'lowercase',
  lineHeight: 1,
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const DownloadButton = styled(Button)(({ theme }) => ({
  maxWidth: 220,
  height: 40,
  backgroundColor: theme.palette.common.white,
  fontWeight: '600',
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: 10,
  color: theme.palette.primary.main,
  '&:disabled': {
    opacity: '0.5',
    color: theme.palette.primary.main,
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));

export const StyledCardMedia = styled(CardMedia)(() => ({
  borderRadius: '30px',
  height: '140px',
  '&:hover': {
    cursor: 'pointer',
  },
}));
